// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternCheckboxGroup_root__3rstM"};